import { useApiQuery } from '@apps/web/swr_data_fetching/use_api_query';

// Plain single-row outreach read with the derived agent status. Use this
// for status polling/refresh loops instead of useJoinedOutreach, which
// fans out to shifts, attempts, and responses on every fetch.
export function useOutreachDetail(
    organizationId: string | null,
    outreachId: string | null,
    traceParams: { readonly reason: string },
    options: Pick<
        Parameters<
            typeof useApiQuery<
                '/organizations/{organization_id}/outreaches/{outreach_id}',
                'get'
            >
        >[0],
        | 'mode'
        | 'refreshInterval'
        | 'refreshWhenHidden'
        | 'shouldRetryOnError'
        | 'errorRetryInterval'
        | 'errorRetryCount'
    > = {},
) {
    return useApiQuery({
        path: '/organizations/{organization_id}/outreaches/{outreach_id}',
        method: 'get',
        pathParams:
            organizationId && outreachId
                ? { organization_id: organizationId, outreach_id: outreachId }
                : undefined,
        enabled: !!organizationId && !!outreachId,
        select: (response) => response,
        reason: traceParams.reason,
        ...options,
    });
}
